/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Event_EndInputs */



/**
* | output |
* | --- |
* | "Snap to Event End" |
*
* @param {Snap_To_Event_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_event_end = /** @type {((inputs?: Snap_To_Event_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Event_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aligner sur la fin de l'événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Am Ereignisende einrasten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggancia alla fine dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти к завершению события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustar al final del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("捕捉到事件结束")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの終了にスナップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समाप्त होने पर क्लिक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ajustar ao fim do evento")
	return /** @type {LocalizedString} */ ("Snap to Event End")
});